import React from "react";
import { fmtSASTDateTime, fmtZAR } from "@/lib/api";

export function Receipt({ data, merchantName, businessAddress, businessPhone }) {
  if (!data) return null;
  const dt = new Date(data.timestamp || Date.now());
  return (
    <div
      data-testid="receipt-block"
      className="print-receipt font-mono text-sm bg-white p-6 max-w-md mx-auto border-t-4 border-dashed border-[#0A2540] shadow-sm flex flex-col gap-2 text-[#333333]"
    >
      <div className="text-center">
        <p className="font-display text-2xl font-bold text-[#0A2540] tracking-tight">FlexiVouch</p>
        <p className="text-[10px] uppercase tracking-[0.2em] text-[#00C4B4]">Stored-value receipt</p>
      </div>
      <div className="border-b border-dashed border-gray-300 my-2" />
      <div className="flex justify-between"><span>Date</span><span>{fmtSASTDateTime(dt)}</span></div>
      <div className="flex justify-between"><span>Service</span><span className="uppercase">{data.service || "general"}</span></div>
      <div className="flex justify-between"><span>Voucher PIN</span><span>{data.pin_masked}</span></div>
      {data.provider_reference && (
        <div className="flex justify-between"><span>Ref</span><span className="text-[11px]">{data.provider_reference}</span></div>
      )}
      <div className="border-b border-dashed border-gray-300 my-2" />
      <div className="flex justify-between"><span>Original value</span><span>{fmtZAR(data.original_amount)}</span></div>
      <div className="flex justify-between font-semibold text-[#0A2540]">
        <span>Redeemed</span><span>− {fmtZAR(data.redeemed_amount)}</span>
      </div>
      <div className="flex justify-between text-[#00C853] font-semibold">
        <span>Remaining balance</span><span>{fmtZAR(data.remaining_balance)}</span>
      </div>
      <div className="border-b border-dashed border-gray-300 my-2" />
      <p className="text-center text-[11px] text-[#666666] leading-relaxed">
        {merchantName || "FlexiVouch Merchant"}<br />
        {businessAddress || "31 5th Street, Commercia, Midrand, 1685"}<br />
        {businessPhone || "079 485 2928"}<br />
        info@praxio.co.za
      </p>
      <p className="text-center text-[10px] text-[#999999] mt-2">Keep this receipt. Vouchers expire 3 years from issue.</p>
    </div>
  );
}
